var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g(_vm._b({staticClass:"p-2.5 app-button",class:[_vm.variant, _vm.brand && `brand-${_vm.brand}`, { selected: _vm.selected, focused: _vm.focused, disabled: _vm.disabled }],attrs:{"disabled":_vm.disabled && _vm.nativeDisabled}},'button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }